var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgContinent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 532,
    height: 102,
    viewBox: "0 0 532 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.62939e-06L3.86603 0.500008L0.866025 5.69616L0 5.19616L3 7.62939e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0L11.866 0.5L8.86602 5.69615L8 5.19615L11 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0L19.866 0.5L16.866 5.69615L16 5.19615L19 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 0L27.866 0.5L24.866 5.69615L24 5.19615L27 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 0L35.866 0.5L32.866 5.69615L32 5.19615L35 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 0L43.866 0.5L40.866 5.69615L40 5.19615L43 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 0L51.866 0.5L48.866 5.69615L48 5.19615L51 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 0L59.866 0.5L56.866 5.69615L56 5.19615L59 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 0L67.866 0.5L64.866 5.69615L64 5.19615L67 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 0L75.866 0.5L72.866 5.69615L72 5.19615L75 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 0L83.866 0.5L80.866 5.69615L80 5.19615L83 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 0L91.866 0.5L88.866 5.69615L88 5.19615L91 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 0L99.866 0.5L96.866 5.69615L96 5.19615L99 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 0L107.866 0.5L104.866 5.69615L104 5.19615L107 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 0L115.866 0.5L112.866 5.69615L112 5.19615L115 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 0L123.866 0.5L120.866 5.69615L120 5.19615L123 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 0L131.866 0.5L128.866 5.69615L128 5.19615L131 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 0L139.866 0.5L136.866 5.69615L136 5.19615L139 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 0L147.866 0.5L144.866 5.69615L144 5.19615L147 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 0L155.866 0.5L152.866 5.69615L152 5.19615L155 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 0L163.866 0.5L160.866 5.69615L160 5.19615L163 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 0L171.866 0.5L168.866 5.69615L168 5.19615L171 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 0L179.866 0.5L176.866 5.69615L176 5.19615L179 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 0L187.866 0.5L184.866 5.69615L184 5.19615L187 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 0L195.866 0.5L192.866 5.69615L192 5.19615L195 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 0L203.866 0.5L200.866 5.69615L200 5.19615L203 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 0L211.866 0.5L208.866 5.69615L208 5.19615L211 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 0L219.866 0.5L216.866 5.69615L216 5.19615L219 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 0L227.866 0.5L224.866 5.69615L224 5.19615L227 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 0L235.866 0.5L232.866 5.69615L232 5.19615L235 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 0L243.866 0.5L240.866 5.69615L240 5.19615L243 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 0L251.866 0.5L248.866 5.69615L248 5.19615L251 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 0L259.866 0.5L256.866 5.69615L256 5.19615L259 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 0L267.866 0.5L264.866 5.69615L264 5.19615L267 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 0L275.866 0.5L272.866 5.69615L272 5.19615L275 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 0L283.866 0.5L280.866 5.69615L280 5.19615L283 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 0L291.866 0.5L288.866 5.69615L288 5.19615L291 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 0L299.866 0.5L296.866 5.69615L296 5.19615L299 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 0L307.866 0.5L304.866 5.69615L304 5.19615L307 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 0L315.866 0.5L312.866 5.69615L312 5.19615L315 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 0L323.866 0.5L320.866 5.69615L320 5.19615L323 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 0L331.866 0.5L328.866 5.69615L328 5.19615L331 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 0L339.866 0.5L336.866 5.69615L336 5.19615L339 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 0L347.866 0.5L344.866 5.69615L344 5.19615L347 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 0L355.866 0.5L352.866 5.69615L352 5.19615L355 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 0L363.866 0.5L360.866 5.69615L360 5.19615L363 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 0L371.866 0.5L368.866 5.69615L368 5.19615L371 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 0L379.866 0.5L376.866 5.69615L376 5.19615L379 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 0L387.866 0.5L384.866 5.69615L384 5.19615L387 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 0L395.866 0.5L392.866 5.69615L392 5.19615L395 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 0L403.866 0.5L400.866 5.69615L400 5.19615L403 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 0L411.866 0.5L408.866 5.69615L408 5.19615L411 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 0L419.866 0.5L416.866 5.69615L416 5.19615L419 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.00001L3.86603 8.50001L0.866025 13.6962L0 13.1962L3 8.00001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8L11.866 8.5L8.86602 13.6962L8 13.1962L11 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8L19.866 8.5L16.866 13.6962L16 13.1962L19 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 8L27.866 8.5L24.866 13.6962L24 13.1962L27 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 8L35.866 8.5L32.866 13.6962L32 13.1962L35 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 8L43.866 8.5L40.866 13.6962L40 13.1962L43 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 8L51.866 8.5L48.866 13.6962L48 13.1962L51 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 8L59.866 8.5L56.866 13.6962L56 13.1962L59 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 8L67.866 8.5L64.866 13.6962L64 13.1962L67 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 8L75.866 8.5L72.866 13.6962L72 13.1962L75 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 8L83.866 8.5L80.866 13.6962L80 13.1962L83 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 8L91.866 8.5L88.866 13.6962L88 13.1962L91 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 8L99.866 8.5L96.866 13.6962L96 13.1962L99 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 8L107.866 8.5L104.866 13.6962L104 13.1962L107 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 8L115.866 8.5L112.866 13.6962L112 13.1962L115 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 8L123.866 8.5L120.866 13.6962L120 13.1962L123 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 8L131.866 8.5L128.866 13.6962L128 13.1962L131 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 8L139.866 8.5L136.866 13.6962L136 13.1962L139 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 8L147.866 8.5L144.866 13.6962L144 13.1962L147 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 8L155.866 8.5L152.866 13.6962L152 13.1962L155 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 8L163.866 8.5L160.866 13.6962L160 13.1962L163 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 8L171.866 8.5L168.866 13.6962L168 13.1962L171 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 8L179.866 8.5L176.866 13.6962L176 13.1962L179 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 8L187.866 8.5L184.866 13.6962L184 13.1962L187 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 8L195.866 8.5L192.866 13.6962L192 13.1962L195 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 8L203.866 8.5L200.866 13.6962L200 13.1962L203 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 8L211.866 8.5L208.866 13.6962L208 13.1962L211 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 8L219.866 8.5L216.866 13.6962L216 13.1962L219 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 8L227.866 8.5L224.866 13.6962L224 13.1962L227 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 8L235.866 8.5L232.866 13.6962L232 13.1962L235 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 8L243.866 8.5L240.866 13.6962L240 13.1962L243 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 8L251.866 8.5L248.866 13.6962L248 13.1962L251 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 8L259.866 8.5L256.866 13.6962L256 13.1962L259 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 8L267.866 8.5L264.866 13.6962L264 13.1962L267 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 8L275.866 8.5L272.866 13.6962L272 13.1962L275 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 8L283.866 8.5L280.866 13.6962L280 13.1962L283 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 8L291.866 8.5L288.866 13.6962L288 13.1962L291 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 8L299.866 8.5L296.866 13.6962L296 13.1962L299 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 8L307.866 8.5L304.866 13.6962L304 13.1962L307 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 8L315.866 8.5L312.866 13.6962L312 13.1962L315 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 8L323.866 8.5L320.866 13.6962L320 13.1962L323 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 8L331.866 8.5L328.866 13.6962L328 13.1962L331 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 8L339.866 8.5L336.866 13.6962L336 13.1962L339 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 8L347.866 8.5L344.866 13.6962L344 13.1962L347 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 8L355.866 8.5L352.866 13.6962L352 13.1962L355 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 8L363.866 8.5L360.866 13.6962L360 13.1962L363 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 8L371.866 8.5L368.866 13.6962L368 13.1962L371 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 8L379.866 8.5L376.866 13.6962L376 13.1962L379 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 8L387.866 8.5L384.866 13.6962L384 13.1962L387 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 8L395.866 8.5L392.866 13.6962L392 13.1962L395 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 8L403.866 8.5L400.866 13.6962L400 13.1962L403 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 8L411.866 8.5L408.866 13.6962L408 13.1962L411 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 8L419.866 8.5L416.866 13.6962L416 13.1962L419 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16L3.86603 16.5L0.866025 21.6962L0 21.1962L3 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16L11.866 16.5L8.86602 21.6962L8 21.1962L11 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 16L19.866 16.5L16.866 21.6962L16 21.1962L19 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16L27.866 16.5L24.866 21.6962L24 21.1962L27 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 16L35.866 16.5L32.866 21.6962L32 21.1962L35 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 16L43.866 16.5L40.866 21.6962L40 21.1962L43 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 16L51.866 16.5L48.866 21.6962L48 21.1962L51 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 16L59.866 16.5L56.866 21.6962L56 21.1962L59 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 16L67.866 16.5L64.866 21.6962L64 21.1962L67 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 16L75.866 16.5L72.866 21.6962L72 21.1962L75 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 16L83.866 16.5L80.866 21.6962L80 21.1962L83 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 16L91.866 16.5L88.866 21.6962L88 21.1962L91 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 16L99.866 16.5L96.866 21.6962L96 21.1962L99 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 16L107.866 16.5L104.866 21.6962L104 21.1962L107 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 16L115.866 16.5L112.866 21.6962L112 21.1962L115 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 16L123.866 16.5L120.866 21.6962L120 21.1962L123 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 16L131.866 16.5L128.866 21.6962L128 21.1962L131 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 16L139.866 16.5L136.866 21.6962L136 21.1962L139 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 16L147.866 16.5L144.866 21.6962L144 21.1962L147 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 16L155.866 16.5L152.866 21.6962L152 21.1962L155 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 16L163.866 16.5L160.866 21.6962L160 21.1962L163 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 16L171.866 16.5L168.866 21.6962L168 21.1962L171 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 16L179.866 16.5L176.866 21.6962L176 21.1962L179 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 16L187.866 16.5L184.866 21.6962L184 21.1962L187 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 16L195.866 16.5L192.866 21.6962L192 21.1962L195 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 16L203.866 16.5L200.866 21.6962L200 21.1962L203 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 16L211.866 16.5L208.866 21.6962L208 21.1962L211 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 16L219.866 16.5L216.866 21.6962L216 21.1962L219 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 16L227.866 16.5L224.866 21.6962L224 21.1962L227 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 16L235.866 16.5L232.866 21.6962L232 21.1962L235 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 16L243.866 16.5L240.866 21.6962L240 21.1962L243 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 16L251.866 16.5L248.866 21.6962L248 21.1962L251 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 16L259.866 16.5L256.866 21.6962L256 21.1962L259 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 16L267.866 16.5L264.866 21.6962L264 21.1962L267 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 16L275.866 16.5L272.866 21.6962L272 21.1962L275 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 16L283.866 16.5L280.866 21.6962L280 21.1962L283 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 16L291.866 16.5L288.866 21.6962L288 21.1962L291 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 16L299.866 16.5L296.866 21.6962L296 21.1962L299 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 16L307.866 16.5L304.866 21.6962L304 21.1962L307 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 16L315.866 16.5L312.866 21.6962L312 21.1962L315 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 16L323.866 16.5L320.866 21.6962L320 21.1962L323 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 16L331.866 16.5L328.866 21.6962L328 21.1962L331 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 16L339.866 16.5L336.866 21.6962L336 21.1962L339 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 16L347.866 16.5L344.866 21.6962L344 21.1962L347 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 16L355.866 16.5L352.866 21.6962L352 21.1962L355 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 16L363.866 16.5L360.866 21.6962L360 21.1962L363 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 16L371.866 16.5L368.866 21.6962L368 21.1962L371 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 16L379.866 16.5L376.866 21.6962L376 21.1962L379 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 16L387.866 16.5L384.866 21.6962L384 21.1962L387 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 16L395.866 16.5L392.866 21.6962L392 21.1962L395 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 16L403.866 16.5L400.866 21.6962L400 21.1962L403 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 16L411.866 16.5L408.866 21.6962L408 21.1962L411 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 16L419.866 16.5L416.866 21.6962L416 21.1962L419 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 24L3.86603 24.5L0.866025 29.6962L0 29.1962L3 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 24L11.866 24.5L8.86602 29.6962L8 29.1962L11 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 24L19.866 24.5L16.866 29.6962L16 29.1962L19 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 24L27.866 24.5L24.866 29.6962L24 29.1962L27 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 24L35.866 24.5L32.866 29.6962L32 29.1962L35 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 24L43.866 24.5L40.866 29.6962L40 29.1962L43 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 24L51.866 24.5L48.866 29.6962L48 29.1962L51 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 24L59.866 24.5L56.866 29.6962L56 29.1962L59 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 24L67.866 24.5L64.866 29.6962L64 29.1962L67 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 24L75.866 24.5L72.866 29.6962L72 29.1962L75 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 24L83.866 24.5L80.866 29.6962L80 29.1962L83 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 24L91.866 24.5L88.866 29.6962L88 29.1962L91 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 24L99.866 24.5L96.866 29.6962L96 29.1962L99 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 24L107.866 24.5L104.866 29.6962L104 29.1962L107 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 24L115.866 24.5L112.866 29.6962L112 29.1962L115 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 24L123.866 24.5L120.866 29.6962L120 29.1962L123 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 24L131.866 24.5L128.866 29.6962L128 29.1962L131 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 24L139.866 24.5L136.866 29.6962L136 29.1962L139 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 24L147.866 24.5L144.866 29.6962L144 29.1962L147 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 24L155.866 24.5L152.866 29.6962L152 29.1962L155 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 24L163.866 24.5L160.866 29.6962L160 29.1962L163 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 24L171.866 24.5L168.866 29.6962L168 29.1962L171 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 24L179.866 24.5L176.866 29.6962L176 29.1962L179 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 24L187.866 24.5L184.866 29.6962L184 29.1962L187 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 24L195.866 24.5L192.866 29.6962L192 29.1962L195 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 24L203.866 24.5L200.866 29.6962L200 29.1962L203 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 24L211.866 24.5L208.866 29.6962L208 29.1962L211 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 24L219.866 24.5L216.866 29.6962L216 29.1962L219 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 24L227.866 24.5L224.866 29.6962L224 29.1962L227 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 24L235.866 24.5L232.866 29.6962L232 29.1962L235 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 24L243.866 24.5L240.866 29.6962L240 29.1962L243 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 24L251.866 24.5L248.866 29.6962L248 29.1962L251 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 24L259.866 24.5L256.866 29.6962L256 29.1962L259 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 24L267.866 24.5L264.866 29.6962L264 29.1962L267 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 24L275.866 24.5L272.866 29.6962L272 29.1962L275 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 24L283.866 24.5L280.866 29.6962L280 29.1962L283 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 24L291.866 24.5L288.866 29.6962L288 29.1962L291 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 24L299.866 24.5L296.866 29.6962L296 29.1962L299 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 24L307.866 24.5L304.866 29.6962L304 29.1962L307 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 24L315.866 24.5L312.866 29.6962L312 29.1962L315 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 24L323.866 24.5L320.866 29.6962L320 29.1962L323 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 24L331.866 24.5L328.866 29.6962L328 29.1962L331 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 24L339.866 24.5L336.866 29.6962L336 29.1962L339 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 24L347.866 24.5L344.866 29.6962L344 29.1962L347 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 24L355.866 24.5L352.866 29.6962L352 29.1962L355 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 24L363.866 24.5L360.866 29.6962L360 29.1962L363 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 24L371.866 24.5L368.866 29.6962L368 29.1962L371 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 24L379.866 24.5L376.866 29.6962L376 29.1962L379 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 24L387.866 24.5L384.866 29.6962L384 29.1962L387 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 24L395.866 24.5L392.866 29.6962L392 29.1962L395 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 24L403.866 24.5L400.866 29.6962L400 29.1962L403 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 24L411.866 24.5L408.866 29.6962L408 29.1962L411 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 24L419.866 24.5L416.866 29.6962L416 29.1962L419 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 32L3.86603 32.5L0.866025 37.6962L0 37.1962L3 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32L11.866 32.5L8.86602 37.6962L8 37.1962L11 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 32L19.866 32.5L16.866 37.6962L16 37.1962L19 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 32L27.866 32.5L24.866 37.6962L24 37.1962L27 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 32L35.866 32.5L32.866 37.6962L32 37.1962L35 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 32L43.866 32.5L40.866 37.6962L40 37.1962L43 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 32L51.866 32.5L48.866 37.6962L48 37.1962L51 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 32L59.866 32.5L56.866 37.6962L56 37.1962L59 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32L67.866 32.5L64.866 37.6962L64 37.1962L67 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 32L75.866 32.5L72.866 37.6962L72 37.1962L75 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 32L83.866 32.5L80.866 37.6962L80 37.1962L83 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 32L91.866 32.5L88.866 37.6962L88 37.1962L91 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 32L99.866 32.5L96.866 37.6962L96 37.1962L99 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 32L107.866 32.5L104.866 37.6962L104 37.1962L107 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 32L115.866 32.5L112.866 37.6962L112 37.1962L115 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 32L123.866 32.5L120.866 37.6962L120 37.1962L123 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 32L131.866 32.5L128.866 37.6962L128 37.1962L131 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 32L139.866 32.5L136.866 37.6962L136 37.1962L139 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 32L147.866 32.5L144.866 37.6962L144 37.1962L147 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 32L155.866 32.5L152.866 37.6962L152 37.1962L155 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 32L163.866 32.5L160.866 37.6962L160 37.1962L163 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 32L171.866 32.5L168.866 37.6962L168 37.1962L171 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 32L179.866 32.5L176.866 37.6962L176 37.1962L179 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 32L187.866 32.5L184.866 37.6962L184 37.1962L187 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 32L195.866 32.5L192.866 37.6962L192 37.1962L195 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 32L203.866 32.5L200.866 37.6962L200 37.1962L203 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 32L211.866 32.5L208.866 37.6962L208 37.1962L211 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 32L219.866 32.5L216.866 37.6962L216 37.1962L219 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 32L227.866 32.5L224.866 37.6962L224 37.1962L227 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 32L235.866 32.5L232.866 37.6962L232 37.1962L235 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 32L243.866 32.5L240.866 37.6962L240 37.1962L243 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 32L251.866 32.5L248.866 37.6962L248 37.1962L251 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 32L259.866 32.5L256.866 37.6962L256 37.1962L259 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 32L267.866 32.5L264.866 37.6962L264 37.1962L267 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 32L275.866 32.5L272.866 37.6962L272 37.1962L275 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 32L283.866 32.5L280.866 37.6962L280 37.1962L283 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 32L291.866 32.5L288.866 37.6962L288 37.1962L291 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 32L299.866 32.5L296.866 37.6962L296 37.1962L299 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 32L307.866 32.5L304.866 37.6962L304 37.1962L307 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 32L315.866 32.5L312.866 37.6962L312 37.1962L315 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 32L323.866 32.5L320.866 37.6962L320 37.1962L323 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 32L331.866 32.5L328.866 37.6962L328 37.1962L331 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 32L339.866 32.5L336.866 37.6962L336 37.1962L339 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 32L347.866 32.5L344.866 37.6962L344 37.1962L347 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 32L355.866 32.5L352.866 37.6962L352 37.1962L355 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 32L363.866 32.5L360.866 37.6962L360 37.1962L363 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 32L371.866 32.5L368.866 37.6962L368 37.1962L371 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 32L379.866 32.5L376.866 37.6962L376 37.1962L379 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 32L387.866 32.5L384.866 37.6962L384 37.1962L387 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 32L395.866 32.5L392.866 37.6962L392 37.1962L395 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 32L403.866 32.5L400.866 37.6962L400 37.1962L403 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 32L411.866 32.5L408.866 37.6962L408 37.1962L411 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 32L419.866 32.5L416.866 37.6962L416 37.1962L419 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 40L3.86603 40.5L0.866025 45.6962L0 45.1962L3 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 40L11.866 40.5L8.86602 45.6962L8 45.1962L11 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 40L19.866 40.5L16.866 45.6962L16 45.1962L19 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 40L27.866 40.5L24.866 45.6962L24 45.1962L27 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 40L35.866 40.5L32.866 45.6962L32 45.1962L35 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 40L43.866 40.5L40.866 45.6962L40 45.1962L43 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 40L51.866 40.5L48.866 45.6962L48 45.1962L51 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 40L59.866 40.5L56.866 45.6962L56 45.1962L59 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 40L67.866 40.5L64.866 45.6962L64 45.1962L67 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 40L75.866 40.5L72.866 45.6962L72 45.1962L75 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 40L83.866 40.5L80.866 45.6962L80 45.1962L83 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 40L91.866 40.5L88.866 45.6962L88 45.1962L91 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 40L99.866 40.5L96.866 45.6962L96 45.1962L99 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 40L107.866 40.5L104.866 45.6962L104 45.1962L107 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 40L115.866 40.5L112.866 45.6962L112 45.1962L115 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 40L123.866 40.5L120.866 45.6962L120 45.1962L123 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 40L131.866 40.5L128.866 45.6962L128 45.1962L131 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 40L139.866 40.5L136.866 45.6962L136 45.1962L139 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 40L147.866 40.5L144.866 45.6962L144 45.1962L147 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 40L155.866 40.5L152.866 45.6962L152 45.1962L155 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 40L163.866 40.5L160.866 45.6962L160 45.1962L163 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 40L171.866 40.5L168.866 45.6962L168 45.1962L171 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 40L179.866 40.5L176.866 45.6962L176 45.1962L179 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 40L187.866 40.5L184.866 45.6962L184 45.1962L187 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 40L195.866 40.5L192.866 45.6962L192 45.1962L195 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 40L203.866 40.5L200.866 45.6962L200 45.1962L203 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 40L211.866 40.5L208.866 45.6962L208 45.1962L211 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 40L219.866 40.5L216.866 45.6962L216 45.1962L219 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 40L227.866 40.5L224.866 45.6962L224 45.1962L227 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 40L235.866 40.5L232.866 45.6962L232 45.1962L235 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 40L243.866 40.5L240.866 45.6962L240 45.1962L243 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 40L251.866 40.5L248.866 45.6962L248 45.1962L251 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 40L259.866 40.5L256.866 45.6962L256 45.1962L259 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 40L267.866 40.5L264.866 45.6962L264 45.1962L267 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 40L275.866 40.5L272.866 45.6962L272 45.1962L275 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 40L283.866 40.5L280.866 45.6962L280 45.1962L283 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 40L291.866 40.5L288.866 45.6962L288 45.1962L291 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 40L299.866 40.5L296.866 45.6962L296 45.1962L299 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 40L307.866 40.5L304.866 45.6962L304 45.1962L307 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 40L315.866 40.5L312.866 45.6962L312 45.1962L315 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 40L323.866 40.5L320.866 45.6962L320 45.1962L323 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 40L331.866 40.5L328.866 45.6962L328 45.1962L331 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 40L339.866 40.5L336.866 45.6962L336 45.1962L339 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 40L347.866 40.5L344.866 45.6962L344 45.1962L347 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 40L355.866 40.5L352.866 45.6962L352 45.1962L355 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 40L363.866 40.5L360.866 45.6962L360 45.1962L363 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 40L371.866 40.5L368.866 45.6962L368 45.1962L371 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 40L379.866 40.5L376.866 45.6962L376 45.1962L379 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 40L387.866 40.5L384.866 45.6962L384 45.1962L387 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 40L395.866 40.5L392.866 45.6962L392 45.1962L395 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 40L403.866 40.5L400.866 45.6962L400 45.1962L403 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 40L411.866 40.5L408.866 45.6962L408 45.1962L411 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 40L419.866 40.5L416.866 45.6962L416 45.1962L419 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 48L3.86603 48.5L0.866025 53.6962L0 53.1962L3 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 48L11.866 48.5L8.86602 53.6962L8 53.1962L11 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 48L19.866 48.5L16.866 53.6962L16 53.1962L19 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 48L27.866 48.5L24.866 53.6962L24 53.1962L27 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 48L35.866 48.5L32.866 53.6962L32 53.1962L35 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 48L43.866 48.5L40.866 53.6962L40 53.1962L43 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 48L51.866 48.5L48.866 53.6962L48 53.1962L51 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 48L59.866 48.5L56.866 53.6962L56 53.1962L59 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 48L67.866 48.5L64.866 53.6962L64 53.1962L67 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 48L75.866 48.5L72.866 53.6962L72 53.1962L75 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 48L83.866 48.5L80.866 53.6962L80 53.1962L83 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 48L91.866 48.5L88.866 53.6962L88 53.1962L91 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 48L99.866 48.5L96.866 53.6962L96 53.1962L99 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 48L107.866 48.5L104.866 53.6962L104 53.1962L107 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 48L115.866 48.5L112.866 53.6962L112 53.1962L115 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 48L123.866 48.5L120.866 53.6962L120 53.1962L123 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 48L131.866 48.5L128.866 53.6962L128 53.1962L131 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 48L139.866 48.5L136.866 53.6962L136 53.1962L139 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 48L147.866 48.5L144.866 53.6962L144 53.1962L147 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 48L155.866 48.5L152.866 53.6962L152 53.1962L155 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 48L163.866 48.5L160.866 53.6962L160 53.1962L163 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 48L171.866 48.5L168.866 53.6962L168 53.1962L171 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 48L179.866 48.5L176.866 53.6962L176 53.1962L179 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 48L187.866 48.5L184.866 53.6962L184 53.1962L187 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 48L195.866 48.5L192.866 53.6962L192 53.1962L195 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 48L203.866 48.5L200.866 53.6962L200 53.1962L203 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 48L211.866 48.5L208.866 53.6962L208 53.1962L211 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 48L219.866 48.5L216.866 53.6962L216 53.1962L219 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 48L227.866 48.5L224.866 53.6962L224 53.1962L227 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 48L235.866 48.5L232.866 53.6962L232 53.1962L235 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 48L243.866 48.5L240.866 53.6962L240 53.1962L243 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 48L251.866 48.5L248.866 53.6962L248 53.1962L251 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 48L259.866 48.5L256.866 53.6962L256 53.1962L259 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 48L267.866 48.5L264.866 53.6962L264 53.1962L267 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 48L275.866 48.5L272.866 53.6962L272 53.1962L275 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 48L283.866 48.5L280.866 53.6962L280 53.1962L283 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 48L291.866 48.5L288.866 53.6962L288 53.1962L291 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 48L299.866 48.5L296.866 53.6962L296 53.1962L299 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 48L307.866 48.5L304.866 53.6962L304 53.1962L307 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 48L315.866 48.5L312.866 53.6962L312 53.1962L315 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 48L323.866 48.5L320.866 53.6962L320 53.1962L323 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 48L331.866 48.5L328.866 53.6962L328 53.1962L331 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 48L339.866 48.5L336.866 53.6962L336 53.1962L339 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 48L347.866 48.5L344.866 53.6962L344 53.1962L347 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 48L355.866 48.5L352.866 53.6962L352 53.1962L355 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 48L363.866 48.5L360.866 53.6962L360 53.1962L363 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 48L371.866 48.5L368.866 53.6962L368 53.1962L371 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 48L379.866 48.5L376.866 53.6962L376 53.1962L379 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 48L387.866 48.5L384.866 53.6962L384 53.1962L387 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 48L395.866 48.5L392.866 53.6962L392 53.1962L395 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 48L403.866 48.5L400.866 53.6962L400 53.1962L403 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 48L411.866 48.5L408.866 53.6962L408 53.1962L411 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 48L419.866 48.5L416.866 53.6962L416 53.1962L419 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 56L3.86603 56.5L0.866025 61.6962L0 61.1962L3 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 56L11.866 56.5L8.86602 61.6962L8 61.1962L11 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 56L19.866 56.5L16.866 61.6962L16 61.1962L19 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 56L27.866 56.5L24.866 61.6962L24 61.1962L27 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 56L35.866 56.5L32.866 61.6962L32 61.1962L35 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 56L43.866 56.5L40.866 61.6962L40 61.1962L43 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 56L51.866 56.5L48.866 61.6962L48 61.1962L51 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 56L59.866 56.5L56.866 61.6962L56 61.1962L59 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 56L67.866 56.5L64.866 61.6962L64 61.1962L67 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 56L75.866 56.5L72.866 61.6962L72 61.1962L75 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 56L83.866 56.5L80.866 61.6962L80 61.1962L83 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 56L91.866 56.5L88.866 61.6962L88 61.1962L91 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 56L99.866 56.5L96.866 61.6962L96 61.1962L99 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 56L107.866 56.5L104.866 61.6962L104 61.1962L107 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 56L115.866 56.5L112.866 61.6962L112 61.1962L115 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 56L123.866 56.5L120.866 61.6962L120 61.1962L123 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 56L131.866 56.5L128.866 61.6962L128 61.1962L131 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 56L139.866 56.5L136.866 61.6962L136 61.1962L139 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 56L147.866 56.5L144.866 61.6962L144 61.1962L147 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 56L155.866 56.5L152.866 61.6962L152 61.1962L155 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 56L163.866 56.5L160.866 61.6962L160 61.1962L163 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 56L171.866 56.5L168.866 61.6962L168 61.1962L171 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 56L179.866 56.5L176.866 61.6962L176 61.1962L179 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 56L187.866 56.5L184.866 61.6962L184 61.1962L187 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 56L195.866 56.5L192.866 61.6962L192 61.1962L195 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 56L203.866 56.5L200.866 61.6962L200 61.1962L203 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 56L211.866 56.5L208.866 61.6962L208 61.1962L211 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 56L219.866 56.5L216.866 61.6962L216 61.1962L219 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 56L227.866 56.5L224.866 61.6962L224 61.1962L227 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 56L235.866 56.5L232.866 61.6962L232 61.1962L235 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 56L243.866 56.5L240.866 61.6962L240 61.1962L243 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 56L251.866 56.5L248.866 61.6962L248 61.1962L251 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 56L259.866 56.5L256.866 61.6962L256 61.1962L259 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 56L267.866 56.5L264.866 61.6962L264 61.1962L267 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 56L275.866 56.5L272.866 61.6962L272 61.1962L275 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 56L283.866 56.5L280.866 61.6962L280 61.1962L283 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 56L291.866 56.5L288.866 61.6962L288 61.1962L291 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 56L299.866 56.5L296.866 61.6962L296 61.1962L299 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 56L307.866 56.5L304.866 61.6962L304 61.1962L307 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 56L315.866 56.5L312.866 61.6962L312 61.1962L315 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 56L323.866 56.5L320.866 61.6962L320 61.1962L323 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 56L331.866 56.5L328.866 61.6962L328 61.1962L331 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 56L339.866 56.5L336.866 61.6962L336 61.1962L339 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 56L347.866 56.5L344.866 61.6962L344 61.1962L347 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 56L355.866 56.5L352.866 61.6962L352 61.1962L355 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 56L363.866 56.5L360.866 61.6962L360 61.1962L363 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 56L371.866 56.5L368.866 61.6962L368 61.1962L371 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 56L379.866 56.5L376.866 61.6962L376 61.1962L379 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 56L387.866 56.5L384.866 61.6962L384 61.1962L387 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 56L395.866 56.5L392.866 61.6962L392 61.1962L395 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 56L403.866 56.5L400.866 61.6962L400 61.1962L403 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 56L411.866 56.5L408.866 61.6962L408 61.1962L411 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 56L419.866 56.5L416.866 61.6962L416 61.1962L419 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 64L3.86603 64.5L0.866025 69.6962L0 69.1962L3 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 64L11.866 64.5L8.86602 69.6962L8 69.1962L11 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 64L19.866 64.5L16.866 69.6962L16 69.1962L19 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 64L27.866 64.5L24.866 69.6962L24 69.1962L27 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 64L35.866 64.5L32.866 69.6962L32 69.1962L35 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 64L43.866 64.5L40.866 69.6962L40 69.1962L43 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 64L51.866 64.5L48.866 69.6962L48 69.1962L51 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 64L59.866 64.5L56.866 69.6962L56 69.1962L59 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 64L67.866 64.5L64.866 69.6962L64 69.1962L67 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 64L75.866 64.5L72.866 69.6962L72 69.1962L75 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 64L83.866 64.5L80.866 69.6962L80 69.1962L83 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 64L91.866 64.5L88.866 69.6962L88 69.1962L91 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 64L99.866 64.5L96.866 69.6962L96 69.1962L99 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 64L107.866 64.5L104.866 69.6962L104 69.1962L107 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 64L115.866 64.5L112.866 69.6962L112 69.1962L115 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 64L123.866 64.5L120.866 69.6962L120 69.1962L123 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 64L131.866 64.5L128.866 69.6962L128 69.1962L131 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 64L139.866 64.5L136.866 69.6962L136 69.1962L139 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 64L147.866 64.5L144.866 69.6962L144 69.1962L147 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 64L155.866 64.5L152.866 69.6962L152 69.1962L155 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 64L163.866 64.5L160.866 69.6962L160 69.1962L163 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 64L171.866 64.5L168.866 69.6962L168 69.1962L171 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 64L179.866 64.5L176.866 69.6962L176 69.1962L179 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 64L187.866 64.5L184.866 69.6962L184 69.1962L187 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 64L195.866 64.5L192.866 69.6962L192 69.1962L195 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 64L203.866 64.5L200.866 69.6962L200 69.1962L203 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 64L211.866 64.5L208.866 69.6962L208 69.1962L211 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 64L219.866 64.5L216.866 69.6962L216 69.1962L219 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 64L227.866 64.5L224.866 69.6962L224 69.1962L227 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 64L235.866 64.5L232.866 69.6962L232 69.1962L235 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 64L243.866 64.5L240.866 69.6962L240 69.1962L243 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 64L251.866 64.5L248.866 69.6962L248 69.1962L251 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 64L259.866 64.5L256.866 69.6962L256 69.1962L259 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 64L267.866 64.5L264.866 69.6962L264 69.1962L267 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 64L275.866 64.5L272.866 69.6962L272 69.1962L275 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 64L283.866 64.5L280.866 69.6962L280 69.1962L283 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 64L291.866 64.5L288.866 69.6962L288 69.1962L291 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 64L299.866 64.5L296.866 69.6962L296 69.1962L299 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 64L307.866 64.5L304.866 69.6962L304 69.1962L307 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 64L315.866 64.5L312.866 69.6962L312 69.1962L315 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 64L323.866 64.5L320.866 69.6962L320 69.1962L323 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 64L331.866 64.5L328.866 69.6962L328 69.1962L331 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 64L339.866 64.5L336.866 69.6962L336 69.1962L339 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 64L347.866 64.5L344.866 69.6962L344 69.1962L347 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 64L355.866 64.5L352.866 69.6962L352 69.1962L355 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 64L363.866 64.5L360.866 69.6962L360 69.1962L363 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 64L371.866 64.5L368.866 69.6962L368 69.1962L371 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 64L379.866 64.5L376.866 69.6962L376 69.1962L379 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 64L387.866 64.5L384.866 69.6962L384 69.1962L387 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 64L395.866 64.5L392.866 69.6962L392 69.1962L395 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 64L403.866 64.5L400.866 69.6962L400 69.1962L403 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 64L411.866 64.5L408.866 69.6962L408 69.1962L411 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 64L419.866 64.5L416.866 69.6962L416 69.1962L419 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 72L3.86603 72.5L0.866025 77.6962L0 77.1962L3 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 72L11.866 72.5L8.86602 77.6962L8 77.1962L11 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 72L19.866 72.5L16.866 77.6962L16 77.1962L19 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 72L27.866 72.5L24.866 77.6962L24 77.1962L27 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 72L35.866 72.5L32.866 77.6962L32 77.1962L35 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 72L43.866 72.5L40.866 77.6962L40 77.1962L43 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 72L51.866 72.5L48.866 77.6962L48 77.1962L51 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 72L59.866 72.5L56.866 77.6962L56 77.1962L59 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 72L67.866 72.5L64.866 77.6962L64 77.1962L67 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 72L75.866 72.5L72.866 77.6962L72 77.1962L75 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 72L83.866 72.5L80.866 77.6962L80 77.1962L83 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 72L91.866 72.5L88.866 77.6962L88 77.1962L91 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 72L99.866 72.5L96.866 77.6962L96 77.1962L99 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 72L107.866 72.5L104.866 77.6962L104 77.1962L107 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 72L115.866 72.5L112.866 77.6962L112 77.1962L115 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 72L123.866 72.5L120.866 77.6962L120 77.1962L123 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 72L131.866 72.5L128.866 77.6962L128 77.1962L131 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 72L139.866 72.5L136.866 77.6962L136 77.1962L139 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 72L147.866 72.5L144.866 77.6962L144 77.1962L147 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 72L155.866 72.5L152.866 77.6962L152 77.1962L155 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 72L163.866 72.5L160.866 77.6962L160 77.1962L163 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 72L171.866 72.5L168.866 77.6962L168 77.1962L171 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 72L179.866 72.5L176.866 77.6962L176 77.1962L179 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 72L187.866 72.5L184.866 77.6962L184 77.1962L187 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 72L195.866 72.5L192.866 77.6962L192 77.1962L195 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 72L203.866 72.5L200.866 77.6962L200 77.1962L203 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 72L211.866 72.5L208.866 77.6962L208 77.1962L211 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 72L219.866 72.5L216.866 77.6962L216 77.1962L219 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 72L227.866 72.5L224.866 77.6962L224 77.1962L227 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 72L235.866 72.5L232.866 77.6962L232 77.1962L235 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 72L243.866 72.5L240.866 77.6962L240 77.1962L243 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 72L251.866 72.5L248.866 77.6962L248 77.1962L251 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 72L259.866 72.5L256.866 77.6962L256 77.1962L259 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 72L267.866 72.5L264.866 77.6962L264 77.1962L267 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 72L275.866 72.5L272.866 77.6962L272 77.1962L275 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 72L283.866 72.5L280.866 77.6962L280 77.1962L283 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 72L291.866 72.5L288.866 77.6962L288 77.1962L291 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 72L299.866 72.5L296.866 77.6962L296 77.1962L299 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 72L307.866 72.5L304.866 77.6962L304 77.1962L307 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 72L315.866 72.5L312.866 77.6962L312 77.1962L315 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 72L323.866 72.5L320.866 77.6962L320 77.1962L323 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 72L331.866 72.5L328.866 77.6962L328 77.1962L331 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 72L339.866 72.5L336.866 77.6962L336 77.1962L339 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 72L347.866 72.5L344.866 77.6962L344 77.1962L347 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 72L355.866 72.5L352.866 77.6962L352 77.1962L355 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 72L363.866 72.5L360.866 77.6962L360 77.1962L363 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 72L371.866 72.5L368.866 77.6962L368 77.1962L371 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 72L379.866 72.5L376.866 77.6962L376 77.1962L379 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 72L387.866 72.5L384.866 77.6962L384 77.1962L387 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 72L395.866 72.5L392.866 77.6962L392 77.1962L395 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 72L403.866 72.5L400.866 77.6962L400 77.1962L403 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 72L411.866 72.5L408.866 77.6962L408 77.1962L411 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 72L419.866 72.5L416.866 77.6962L416 77.1962L419 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 80L3.86603 80.5L0.866025 85.6962L0 85.1962L3 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 80L11.866 80.5L8.86602 85.6962L8 85.1962L11 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 80L19.866 80.5L16.866 85.6962L16 85.1962L19 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 80L27.866 80.5L24.866 85.6962L24 85.1962L27 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 80L35.866 80.5L32.866 85.6962L32 85.1962L35 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 80L43.866 80.5L40.866 85.6962L40 85.1962L43 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 80L51.866 80.5L48.866 85.6962L48 85.1962L51 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 80L59.866 80.5L56.866 85.6962L56 85.1962L59 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 80L67.866 80.5L64.866 85.6962L64 85.1962L67 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 80L75.866 80.5L72.866 85.6962L72 85.1962L75 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 80L83.866 80.5L80.866 85.6962L80 85.1962L83 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 80L91.866 80.5L88.866 85.6962L88 85.1962L91 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 80L99.866 80.5L96.866 85.6962L96 85.1962L99 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 80L107.866 80.5L104.866 85.6962L104 85.1962L107 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 80L115.866 80.5L112.866 85.6962L112 85.1962L115 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 80L123.866 80.5L120.866 85.6962L120 85.1962L123 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 80L131.866 80.5L128.866 85.6962L128 85.1962L131 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 80L139.866 80.5L136.866 85.6962L136 85.1962L139 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 80L147.866 80.5L144.866 85.6962L144 85.1962L147 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 80L155.866 80.5L152.866 85.6962L152 85.1962L155 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 80L163.866 80.5L160.866 85.6962L160 85.1962L163 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 80L171.866 80.5L168.866 85.6962L168 85.1962L171 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 80L179.866 80.5L176.866 85.6962L176 85.1962L179 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 80L187.866 80.5L184.866 85.6962L184 85.1962L187 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 80L195.866 80.5L192.866 85.6962L192 85.1962L195 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 80L203.866 80.5L200.866 85.6962L200 85.1962L203 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 80L211.866 80.5L208.866 85.6962L208 85.1962L211 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 80L219.866 80.5L216.866 85.6962L216 85.1962L219 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 80L227.866 80.5L224.866 85.6962L224 85.1962L227 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 80L235.866 80.5L232.866 85.6962L232 85.1962L235 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 80L243.866 80.5L240.866 85.6962L240 85.1962L243 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 80L251.866 80.5L248.866 85.6962L248 85.1962L251 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 80L259.866 80.5L256.866 85.6962L256 85.1962L259 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 80L267.866 80.5L264.866 85.6962L264 85.1962L267 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 80L275.866 80.5L272.866 85.6962L272 85.1962L275 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 80L283.866 80.5L280.866 85.6962L280 85.1962L283 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 80L291.866 80.5L288.866 85.6962L288 85.1962L291 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 80L299.866 80.5L296.866 85.6962L296 85.1962L299 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 80L307.866 80.5L304.866 85.6962L304 85.1962L307 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 80L315.866 80.5L312.866 85.6962L312 85.1962L315 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 80L323.866 80.5L320.866 85.6962L320 85.1962L323 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 80L331.866 80.5L328.866 85.6962L328 85.1962L331 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 80L339.866 80.5L336.866 85.6962L336 85.1962L339 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 80L347.866 80.5L344.866 85.6962L344 85.1962L347 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 80L355.866 80.5L352.866 85.6962L352 85.1962L355 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 80L363.866 80.5L360.866 85.6962L360 85.1962L363 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 80L371.866 80.5L368.866 85.6962L368 85.1962L371 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 80L379.866 80.5L376.866 85.6962L376 85.1962L379 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 80L387.866 80.5L384.866 85.6962L384 85.1962L387 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 80L395.866 80.5L392.866 85.6962L392 85.1962L395 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 80L403.866 80.5L400.866 85.6962L400 85.1962L403 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 80L411.866 80.5L408.866 85.6962L408 85.1962L411 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 80L419.866 80.5L416.866 85.6962L416 85.1962L419 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 88L3.86603 88.5L0.866025 93.6962L0 93.1962L3 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 88L11.866 88.5L8.86602 93.6962L8 93.1962L11 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 88L19.866 88.5L16.866 93.6962L16 93.1962L19 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 88L27.866 88.5L24.866 93.6962L24 93.1962L27 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 88L35.866 88.5L32.866 93.6962L32 93.1962L35 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 88L43.866 88.5L40.866 93.6962L40 93.1962L43 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 88L51.866 88.5L48.866 93.6962L48 93.1962L51 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 88L59.866 88.5L56.866 93.6962L56 93.1962L59 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 88L67.866 88.5L64.866 93.6962L64 93.1962L67 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 88L75.866 88.5L72.866 93.6962L72 93.1962L75 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 88L83.866 88.5L80.866 93.6962L80 93.1962L83 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 88L91.866 88.5L88.866 93.6962L88 93.1962L91 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 88L99.866 88.5L96.866 93.6962L96 93.1962L99 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 88L107.866 88.5L104.866 93.6962L104 93.1962L107 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 88L115.866 88.5L112.866 93.6962L112 93.1962L115 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 88L123.866 88.5L120.866 93.6962L120 93.1962L123 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 88L131.866 88.5L128.866 93.6962L128 93.1962L131 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 88L139.866 88.5L136.866 93.6962L136 93.1962L139 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 88L147.866 88.5L144.866 93.6962L144 93.1962L147 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 88L155.866 88.5L152.866 93.6962L152 93.1962L155 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 88L163.866 88.5L160.866 93.6962L160 93.1962L163 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 88L171.866 88.5L168.866 93.6962L168 93.1962L171 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 88L179.866 88.5L176.866 93.6962L176 93.1962L179 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 88L187.866 88.5L184.866 93.6962L184 93.1962L187 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 88L195.866 88.5L192.866 93.6962L192 93.1962L195 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 88L203.866 88.5L200.866 93.6962L200 93.1962L203 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 88L211.866 88.5L208.866 93.6962L208 93.1962L211 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 88L219.866 88.5L216.866 93.6962L216 93.1962L219 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 88L227.866 88.5L224.866 93.6962L224 93.1962L227 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 88L235.866 88.5L232.866 93.6962L232 93.1962L235 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 88L243.866 88.5L240.866 93.6962L240 93.1962L243 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 88L251.866 88.5L248.866 93.6962L248 93.1962L251 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 88L259.866 88.5L256.866 93.6962L256 93.1962L259 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 88L267.866 88.5L264.866 93.6962L264 93.1962L267 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 88L275.866 88.5L272.866 93.6962L272 93.1962L275 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 88L283.866 88.5L280.866 93.6962L280 93.1962L283 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 88L291.866 88.5L288.866 93.6962L288 93.1962L291 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 88L299.866 88.5L296.866 93.6962L296 93.1962L299 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 88L307.866 88.5L304.866 93.6962L304 93.1962L307 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 88L315.866 88.5L312.866 93.6962L312 93.1962L315 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 88L323.866 88.5L320.866 93.6962L320 93.1962L323 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 88L331.866 88.5L328.866 93.6962L328 93.1962L331 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 88L339.866 88.5L336.866 93.6962L336 93.1962L339 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 88L347.866 88.5L344.866 93.6962L344 93.1962L347 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 88L355.866 88.5L352.866 93.6962L352 93.1962L355 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 88L363.866 88.5L360.866 93.6962L360 93.1962L363 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 88L371.866 88.5L368.866 93.6962L368 93.1962L371 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 88L379.866 88.5L376.866 93.6962L376 93.1962L379 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 88L387.866 88.5L384.866 93.6962L384 93.1962L387 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 88L395.866 88.5L392.866 93.6962L392 93.1962L395 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 88L403.866 88.5L400.866 93.6962L400 93.1962L403 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 88L411.866 88.5L408.866 93.6962L408 93.1962L411 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 88L419.866 88.5L416.866 93.6962L416 93.1962L419 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 96L3.86603 96.5L0.866025 101.696L0 101.196L3 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 96L11.866 96.5L8.86602 101.696L8 101.196L11 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 96L19.866 96.5L16.866 101.696L16 101.196L19 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 96L27.866 96.5L24.866 101.696L24 101.196L27 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 96L35.866 96.5L32.866 101.696L32 101.196L35 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 96L43.866 96.5L40.866 101.696L40 101.196L43 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 96L51.866 96.5L48.866 101.696L48 101.196L51 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 96L59.866 96.5L56.866 101.696L56 101.196L59 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 96L67.866 96.5L64.866 101.696L64 101.196L67 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 96L75.866 96.5L72.866 101.696L72 101.196L75 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 96L83.866 96.5L80.866 101.696L80 101.196L83 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 96L91.866 96.5L88.866 101.696L88 101.196L91 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 96L99.866 96.5L96.866 101.696L96 101.196L99 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 96L107.866 96.5L104.866 101.696L104 101.196L107 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 96L115.866 96.5L112.866 101.696L112 101.196L115 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 96L123.866 96.5L120.866 101.696L120 101.196L123 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 96L131.866 96.5L128.866 101.696L128 101.196L131 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 96L139.866 96.5L136.866 101.696L136 101.196L139 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 96L147.866 96.5L144.866 101.696L144 101.196L147 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155 96L155.866 96.5L152.866 101.696L152 101.196L155 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 96L163.866 96.5L160.866 101.696L160 101.196L163 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 96L171.866 96.5L168.866 101.696L168 101.196L171 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 96L179.866 96.5L176.866 101.696L176 101.196L179 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 96L187.866 96.5L184.866 101.696L184 101.196L187 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 96L195.866 96.5L192.866 101.696L192 101.196L195 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203 96L203.866 96.5L200.866 101.696L200 101.196L203 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 96L211.866 96.5L208.866 101.696L208 101.196L211 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 96L219.866 96.5L216.866 101.696L216 101.196L219 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 96L227.866 96.5L224.866 101.696L224 101.196L227 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 96L235.866 96.5L232.866 101.696L232 101.196L235 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 96L243.866 96.5L240.866 101.696L240 101.196L243 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 96L251.866 96.5L248.866 101.696L248 101.196L251 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 96L259.866 96.5L256.866 101.696L256 101.196L259 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267 96L267.866 96.5L264.866 101.696L264 101.196L267 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 96L275.866 96.5L272.866 101.696L272 101.196L275 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 96L283.866 96.5L280.866 101.696L280 101.196L283 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 96L291.866 96.5L288.866 101.696L288 101.196L291 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 96L299.866 96.5L296.866 101.696L296 101.196L299 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 96L307.866 96.5L304.866 101.696L304 101.196L307 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315 96L315.866 96.5L312.866 101.696L312 101.196L315 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 96L323.866 96.5L320.866 101.696L320 101.196L323 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331 96L331.866 96.5L328.866 101.696L328 101.196L331 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 96L339.866 96.5L336.866 101.696L336 101.196L339 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 96L347.866 96.5L344.866 101.696L344 101.196L347 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355 96L355.866 96.5L352.866 101.696L352 101.196L355 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363 96L363.866 96.5L360.866 101.696L360 101.196L363 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371 96L371.866 96.5L368.866 101.696L368 101.196L371 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 96L379.866 96.5L376.866 101.696L376 101.196L379 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387 96L387.866 96.5L384.866 101.696L384 101.196L387 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395 96L395.866 96.5L392.866 101.696L392 101.196L395 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 96L403.866 96.5L400.866 101.696L400 101.196L403 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411 96L411.866 96.5L408.866 101.696L408 101.196L411 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 96L419.866 96.5L416.866 101.696L416 101.196L419 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 7.62939e-06L427.866 0.500008L424.866 5.69616L424 5.19616L427 7.62939e-06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 0L435.866 0.5L432.866 5.69615L432 5.19615L435 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 0L443.866 0.5L440.866 5.69615L440 5.19615L443 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 0L451.866 0.5L448.866 5.69615L448 5.19615L451 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 0L459.866 0.5L456.866 5.69615L456 5.19615L459 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 0L467.866 0.5L464.866 5.69615L464 5.19615L467 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 0L475.866 0.5L472.866 5.69615L472 5.19615L475 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 0L483.866 0.5L480.866 5.69615L480 5.19615L483 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 0L491.866 0.5L488.866 5.69615L488 5.19615L491 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 0L499.866 0.5L496.866 5.69615L496 5.19615L499 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 0L507.866 0.5L504.866 5.69615L504 5.19615L507 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 0L515.866 0.5L512.866 5.69615L512 5.19615L515 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 0L523.866 0.5L520.866 5.69615L520 5.19615L523 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 0L531.866 0.5L528.866 5.69615L528 5.19615L531 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 0L539.866 0.5L536.866 5.69615L536 5.19615L539 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 0L547.866 0.5L544.866 5.69615L544 5.19615L547 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 0L555.866 0.5L552.866 5.69615L552 5.19615L555 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 0L563.866 0.5L560.866 5.69615L560 5.19615L563 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 0L571.866 0.5L568.866 5.69615L568 5.19615L571 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 0L579.866 0.5L576.866 5.69615L576 5.19615L579 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 0L587.866 0.5L584.866 5.69615L584 5.19615L587 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 0L595.866 0.5L592.866 5.69615L592 5.19615L595 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 0L603.866 0.5L600.866 5.69615L600 5.19615L603 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 0L611.866 0.5L608.866 5.69615L608 5.19615L611 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 0L619.866 0.5L616.866 5.69615L616 5.19615L619 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 0L627.866 0.5L624.866 5.69615L624 5.19615L627 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 0L635.866 0.5L632.866 5.69615L632 5.19615L635 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 0L643.866 0.5L640.866 5.69615L640 5.19615L643 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 0L651.866 0.5L648.866 5.69615L648 5.19615L651 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 0L659.866 0.5L656.866 5.69615L656 5.19615L659 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 0L667.866 0.5L664.866 5.69615L664 5.19615L667 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 0L675.866 0.5L672.866 5.69615L672 5.19615L675 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 0L683.866 0.5L680.866 5.69615L680 5.19615L683 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 0L691.866 0.5L688.866 5.69615L688 5.19615L691 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 0L699.866 0.5L696.866 5.69615L696 5.19615L699 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 0L707.866 0.5L704.866 5.69615L704 5.19615L707 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 0L715.866 0.5L712.866 5.69615L712 5.19615L715 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 0L723.866 0.5L720.866 5.69615L720 5.19615L723 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 0L731.866 0.5L728.866 5.69615L728 5.19615L731 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 0L739.866 0.5L736.866 5.69615L736 5.19615L739 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 0L747.866 0.5L744.866 5.69615L744 5.19615L747 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 0L755.866 0.5L752.866 5.69615L752 5.19615L755 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 0L763.866 0.5L760.866 5.69615L760 5.19615L763 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 0L771.866 0.5L768.866 5.69615L768 5.19615L771 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 0L779.866 0.5L776.866 5.69615L776 5.19615L779 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 0L787.866 0.5L784.866 5.69615L784 5.19615L787 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 0L795.866 0.5L792.866 5.69615L792 5.19615L795 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 0L803.866 0.5L800.866 5.69615L800 5.19615L803 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 0L811.866 0.5L808.866 5.69615L808 5.19615L811 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 0L819.866 0.5L816.866 5.69615L816 5.19615L819 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 0L827.866 0.5L824.866 5.69615L824 5.19615L827 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 0L835.866 0.5L832.866 5.69615L832 5.19615L835 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 0L843.866 0.5L840.866 5.69615L840 5.19615L843 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 8.00001L427.866 8.50001L424.866 13.6962L424 13.1962L427 8.00001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 8L435.866 8.5L432.866 13.6962L432 13.1962L435 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 8L443.866 8.5L440.866 13.6962L440 13.1962L443 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 8L451.866 8.5L448.866 13.6962L448 13.1962L451 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 8L459.866 8.5L456.866 13.6962L456 13.1962L459 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 8L467.866 8.5L464.866 13.6962L464 13.1962L467 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 8L475.866 8.5L472.866 13.6962L472 13.1962L475 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 8L483.866 8.5L480.866 13.6962L480 13.1962L483 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 8L491.866 8.5L488.866 13.6962L488 13.1962L491 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 8L499.866 8.5L496.866 13.6962L496 13.1962L499 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 8L507.866 8.5L504.866 13.6962L504 13.1962L507 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 8L515.866 8.5L512.866 13.6962L512 13.1962L515 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 8L523.866 8.5L520.866 13.6962L520 13.1962L523 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 8L531.866 8.5L528.866 13.6962L528 13.1962L531 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 8L539.866 8.5L536.866 13.6962L536 13.1962L539 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 8L547.866 8.5L544.866 13.6962L544 13.1962L547 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 8L555.866 8.5L552.866 13.6962L552 13.1962L555 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 8L563.866 8.5L560.866 13.6962L560 13.1962L563 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 8L571.866 8.5L568.866 13.6962L568 13.1962L571 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 8L579.866 8.5L576.866 13.6962L576 13.1962L579 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 8L587.866 8.5L584.866 13.6962L584 13.1962L587 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 8L595.866 8.5L592.866 13.6962L592 13.1962L595 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 8L603.866 8.5L600.866 13.6962L600 13.1962L603 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 8L611.866 8.5L608.866 13.6962L608 13.1962L611 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 8L619.866 8.5L616.866 13.6962L616 13.1962L619 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 8L627.866 8.5L624.866 13.6962L624 13.1962L627 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 8L635.866 8.5L632.866 13.6962L632 13.1962L635 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 8L643.866 8.5L640.866 13.6962L640 13.1962L643 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 8L651.866 8.5L648.866 13.6962L648 13.1962L651 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 8L659.866 8.5L656.866 13.6962L656 13.1962L659 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 8L667.866 8.5L664.866 13.6962L664 13.1962L667 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 8L675.866 8.5L672.866 13.6962L672 13.1962L675 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 8L683.866 8.5L680.866 13.6962L680 13.1962L683 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 8L691.866 8.5L688.866 13.6962L688 13.1962L691 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 8L699.866 8.5L696.866 13.6962L696 13.1962L699 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 8L707.866 8.5L704.866 13.6962L704 13.1962L707 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 8L715.866 8.5L712.866 13.6962L712 13.1962L715 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 8L723.866 8.5L720.866 13.6962L720 13.1962L723 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 8L731.866 8.5L728.866 13.6962L728 13.1962L731 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 8L739.866 8.5L736.866 13.6962L736 13.1962L739 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 8L747.866 8.5L744.866 13.6962L744 13.1962L747 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 8L755.866 8.5L752.866 13.6962L752 13.1962L755 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 8L763.866 8.5L760.866 13.6962L760 13.1962L763 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 8L771.866 8.5L768.866 13.6962L768 13.1962L771 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 8L779.866 8.5L776.866 13.6962L776 13.1962L779 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 8L787.866 8.5L784.866 13.6962L784 13.1962L787 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 8L795.866 8.5L792.866 13.6962L792 13.1962L795 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 8L803.866 8.5L800.866 13.6962L800 13.1962L803 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 8L811.866 8.5L808.866 13.6962L808 13.1962L811 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 8L819.866 8.5L816.866 13.6962L816 13.1962L819 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 8L827.866 8.5L824.866 13.6962L824 13.1962L827 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 8L835.866 8.5L832.866 13.6962L832 13.1962L835 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 8L843.866 8.5L840.866 13.6962L840 13.1962L843 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 16L427.866 16.5L424.866 21.6962L424 21.1962L427 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 16L435.866 16.5L432.866 21.6962L432 21.1962L435 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 16L443.866 16.5L440.866 21.6962L440 21.1962L443 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 16L451.866 16.5L448.866 21.6962L448 21.1962L451 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 16L459.866 16.5L456.866 21.6962L456 21.1962L459 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 16L467.866 16.5L464.866 21.6962L464 21.1962L467 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 16L475.866 16.5L472.866 21.6962L472 21.1962L475 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 16L483.866 16.5L480.866 21.6962L480 21.1962L483 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 16L491.866 16.5L488.866 21.6962L488 21.1962L491 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 16L499.866 16.5L496.866 21.6962L496 21.1962L499 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 16L507.866 16.5L504.866 21.6962L504 21.1962L507 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 16L515.866 16.5L512.866 21.6962L512 21.1962L515 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 16L523.866 16.5L520.866 21.6962L520 21.1962L523 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 16L531.866 16.5L528.866 21.6962L528 21.1962L531 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 16L539.866 16.5L536.866 21.6962L536 21.1962L539 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 16L547.866 16.5L544.866 21.6962L544 21.1962L547 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 16L555.866 16.5L552.866 21.6962L552 21.1962L555 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 16L563.866 16.5L560.866 21.6962L560 21.1962L563 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 16L571.866 16.5L568.866 21.6962L568 21.1962L571 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 16L579.866 16.5L576.866 21.6962L576 21.1962L579 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 16L587.866 16.5L584.866 21.6962L584 21.1962L587 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 16L595.866 16.5L592.866 21.6962L592 21.1962L595 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 16L603.866 16.5L600.866 21.6962L600 21.1962L603 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 16L611.866 16.5L608.866 21.6962L608 21.1962L611 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 16L619.866 16.5L616.866 21.6962L616 21.1962L619 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 16L627.866 16.5L624.866 21.6962L624 21.1962L627 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 16L635.866 16.5L632.866 21.6962L632 21.1962L635 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 16L643.866 16.5L640.866 21.6962L640 21.1962L643 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 16L651.866 16.5L648.866 21.6962L648 21.1962L651 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 16L659.866 16.5L656.866 21.6962L656 21.1962L659 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 16L667.866 16.5L664.866 21.6962L664 21.1962L667 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 16L675.866 16.5L672.866 21.6962L672 21.1962L675 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 16L683.866 16.5L680.866 21.6962L680 21.1962L683 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 16L691.866 16.5L688.866 21.6962L688 21.1962L691 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 16L699.866 16.5L696.866 21.6962L696 21.1962L699 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 16L707.866 16.5L704.866 21.6962L704 21.1962L707 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 16L715.866 16.5L712.866 21.6962L712 21.1962L715 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 16L723.866 16.5L720.866 21.6962L720 21.1962L723 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 16L731.866 16.5L728.866 21.6962L728 21.1962L731 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 16L739.866 16.5L736.866 21.6962L736 21.1962L739 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 16L747.866 16.5L744.866 21.6962L744 21.1962L747 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 16L755.866 16.5L752.866 21.6962L752 21.1962L755 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 16L763.866 16.5L760.866 21.6962L760 21.1962L763 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 16L771.866 16.5L768.866 21.6962L768 21.1962L771 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 16L779.866 16.5L776.866 21.6962L776 21.1962L779 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 16L787.866 16.5L784.866 21.6962L784 21.1962L787 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 16L795.866 16.5L792.866 21.6962L792 21.1962L795 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 16L803.866 16.5L800.866 21.6962L800 21.1962L803 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 16L811.866 16.5L808.866 21.6962L808 21.1962L811 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 16L819.866 16.5L816.866 21.6962L816 21.1962L819 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 16L827.866 16.5L824.866 21.6962L824 21.1962L827 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 16L835.866 16.5L832.866 21.6962L832 21.1962L835 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 16L843.866 16.5L840.866 21.6962L840 21.1962L843 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 24L427.866 24.5L424.866 29.6962L424 29.1962L427 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 24L435.866 24.5L432.866 29.6962L432 29.1962L435 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 24L443.866 24.5L440.866 29.6962L440 29.1962L443 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 24L451.866 24.5L448.866 29.6962L448 29.1962L451 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 24L459.866 24.5L456.866 29.6962L456 29.1962L459 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 24L467.866 24.5L464.866 29.6962L464 29.1962L467 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 24L475.866 24.5L472.866 29.6962L472 29.1962L475 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 24L483.866 24.5L480.866 29.6962L480 29.1962L483 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 24L491.866 24.5L488.866 29.6962L488 29.1962L491 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 24L499.866 24.5L496.866 29.6962L496 29.1962L499 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 24L507.866 24.5L504.866 29.6962L504 29.1962L507 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 24L515.866 24.5L512.866 29.6962L512 29.1962L515 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 24L523.866 24.5L520.866 29.6962L520 29.1962L523 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 24L531.866 24.5L528.866 29.6962L528 29.1962L531 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 24L539.866 24.5L536.866 29.6962L536 29.1962L539 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 24L547.866 24.5L544.866 29.6962L544 29.1962L547 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 24L555.866 24.5L552.866 29.6962L552 29.1962L555 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 24L563.866 24.5L560.866 29.6962L560 29.1962L563 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 24L571.866 24.5L568.866 29.6962L568 29.1962L571 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 24L579.866 24.5L576.866 29.6962L576 29.1962L579 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 24L587.866 24.5L584.866 29.6962L584 29.1962L587 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 24L595.866 24.5L592.866 29.6962L592 29.1962L595 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 24L603.866 24.5L600.866 29.6962L600 29.1962L603 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 24L611.866 24.5L608.866 29.6962L608 29.1962L611 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 24L619.866 24.5L616.866 29.6962L616 29.1962L619 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 24L627.866 24.5L624.866 29.6962L624 29.1962L627 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 24L635.866 24.5L632.866 29.6962L632 29.1962L635 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 24L643.866 24.5L640.866 29.6962L640 29.1962L643 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 24L651.866 24.5L648.866 29.6962L648 29.1962L651 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 24L659.866 24.5L656.866 29.6962L656 29.1962L659 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 24L667.866 24.5L664.866 29.6962L664 29.1962L667 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 24L675.866 24.5L672.866 29.6962L672 29.1962L675 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 24L683.866 24.5L680.866 29.6962L680 29.1962L683 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 24L691.866 24.5L688.866 29.6962L688 29.1962L691 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 24L699.866 24.5L696.866 29.6962L696 29.1962L699 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 24L707.866 24.5L704.866 29.6962L704 29.1962L707 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 24L715.866 24.5L712.866 29.6962L712 29.1962L715 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 24L723.866 24.5L720.866 29.6962L720 29.1962L723 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 24L731.866 24.5L728.866 29.6962L728 29.1962L731 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 24L739.866 24.5L736.866 29.6962L736 29.1962L739 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 24L747.866 24.5L744.866 29.6962L744 29.1962L747 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 24L755.866 24.5L752.866 29.6962L752 29.1962L755 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 24L763.866 24.5L760.866 29.6962L760 29.1962L763 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 24L771.866 24.5L768.866 29.6962L768 29.1962L771 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 24L779.866 24.5L776.866 29.6962L776 29.1962L779 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 24L787.866 24.5L784.866 29.6962L784 29.1962L787 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 24L795.866 24.5L792.866 29.6962L792 29.1962L795 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 24L803.866 24.5L800.866 29.6962L800 29.1962L803 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 24L811.866 24.5L808.866 29.6962L808 29.1962L811 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 24L819.866 24.5L816.866 29.6962L816 29.1962L819 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 24L827.866 24.5L824.866 29.6962L824 29.1962L827 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 24L835.866 24.5L832.866 29.6962L832 29.1962L835 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 24L843.866 24.5L840.866 29.6962L840 29.1962L843 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 32L427.866 32.5L424.866 37.6962L424 37.1962L427 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 32L435.866 32.5L432.866 37.6962L432 37.1962L435 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 32L443.866 32.5L440.866 37.6962L440 37.1962L443 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 32L451.866 32.5L448.866 37.6962L448 37.1962L451 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 32L459.866 32.5L456.866 37.6962L456 37.1962L459 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 32L467.866 32.5L464.866 37.6962L464 37.1962L467 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 32L475.866 32.5L472.866 37.6962L472 37.1962L475 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 32L483.866 32.5L480.866 37.6962L480 37.1962L483 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 32L491.866 32.5L488.866 37.6962L488 37.1962L491 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 32L499.866 32.5L496.866 37.6962L496 37.1962L499 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 32L507.866 32.5L504.866 37.6962L504 37.1962L507 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 32L515.866 32.5L512.866 37.6962L512 37.1962L515 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 32L523.866 32.5L520.866 37.6962L520 37.1962L523 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 32L531.866 32.5L528.866 37.6962L528 37.1962L531 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 32L539.866 32.5L536.866 37.6962L536 37.1962L539 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 32L547.866 32.5L544.866 37.6962L544 37.1962L547 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 32L555.866 32.5L552.866 37.6962L552 37.1962L555 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 32L563.866 32.5L560.866 37.6962L560 37.1962L563 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 32L571.866 32.5L568.866 37.6962L568 37.1962L571 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 32L579.866 32.5L576.866 37.6962L576 37.1962L579 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 32L587.866 32.5L584.866 37.6962L584 37.1962L587 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 32L595.866 32.5L592.866 37.6962L592 37.1962L595 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 32L603.866 32.5L600.866 37.6962L600 37.1962L603 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 32L611.866 32.5L608.866 37.6962L608 37.1962L611 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 32L619.866 32.5L616.866 37.6962L616 37.1962L619 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 32L627.866 32.5L624.866 37.6962L624 37.1962L627 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 32L635.866 32.5L632.866 37.6962L632 37.1962L635 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 32L643.866 32.5L640.866 37.6962L640 37.1962L643 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 32L651.866 32.5L648.866 37.6962L648 37.1962L651 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 32L659.866 32.5L656.866 37.6962L656 37.1962L659 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 32L667.866 32.5L664.866 37.6962L664 37.1962L667 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 32L675.866 32.5L672.866 37.6962L672 37.1962L675 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 32L683.866 32.5L680.866 37.6962L680 37.1962L683 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 32L691.866 32.5L688.866 37.6962L688 37.1962L691 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 32L699.866 32.5L696.866 37.6962L696 37.1962L699 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 32L707.866 32.5L704.866 37.6962L704 37.1962L707 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 32L715.866 32.5L712.866 37.6962L712 37.1962L715 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 32L723.866 32.5L720.866 37.6962L720 37.1962L723 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 32L731.866 32.5L728.866 37.6962L728 37.1962L731 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 32L739.866 32.5L736.866 37.6962L736 37.1962L739 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 32L747.866 32.5L744.866 37.6962L744 37.1962L747 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 32L755.866 32.5L752.866 37.6962L752 37.1962L755 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 32L763.866 32.5L760.866 37.6962L760 37.1962L763 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 32L771.866 32.5L768.866 37.6962L768 37.1962L771 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 32L779.866 32.5L776.866 37.6962L776 37.1962L779 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 32L787.866 32.5L784.866 37.6962L784 37.1962L787 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 32L795.866 32.5L792.866 37.6962L792 37.1962L795 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 32L803.866 32.5L800.866 37.6962L800 37.1962L803 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 32L811.866 32.5L808.866 37.6962L808 37.1962L811 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 32L819.866 32.5L816.866 37.6962L816 37.1962L819 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 32L827.866 32.5L824.866 37.6962L824 37.1962L827 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 32L835.866 32.5L832.866 37.6962L832 37.1962L835 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 32L843.866 32.5L840.866 37.6962L840 37.1962L843 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 40L427.866 40.5L424.866 45.6962L424 45.1962L427 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 40L435.866 40.5L432.866 45.6962L432 45.1962L435 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 40L443.866 40.5L440.866 45.6962L440 45.1962L443 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 40L451.866 40.5L448.866 45.6962L448 45.1962L451 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 40L459.866 40.5L456.866 45.6962L456 45.1962L459 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 40L467.866 40.5L464.866 45.6962L464 45.1962L467 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 40L475.866 40.5L472.866 45.6962L472 45.1962L475 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 40L483.866 40.5L480.866 45.6962L480 45.1962L483 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 40L491.866 40.5L488.866 45.6962L488 45.1962L491 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 40L499.866 40.5L496.866 45.6962L496 45.1962L499 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 40L507.866 40.5L504.866 45.6962L504 45.1962L507 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 40L515.866 40.5L512.866 45.6962L512 45.1962L515 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 40L523.866 40.5L520.866 45.6962L520 45.1962L523 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 40L531.866 40.5L528.866 45.6962L528 45.1962L531 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 40L539.866 40.5L536.866 45.6962L536 45.1962L539 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 40L547.866 40.5L544.866 45.6962L544 45.1962L547 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 40L555.866 40.5L552.866 45.6962L552 45.1962L555 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 40L563.866 40.5L560.866 45.6962L560 45.1962L563 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 40L571.866 40.5L568.866 45.6962L568 45.1962L571 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 40L579.866 40.5L576.866 45.6962L576 45.1962L579 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 40L587.866 40.5L584.866 45.6962L584 45.1962L587 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 40L595.866 40.5L592.866 45.6962L592 45.1962L595 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 40L603.866 40.5L600.866 45.6962L600 45.1962L603 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 40L611.866 40.5L608.866 45.6962L608 45.1962L611 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 40L619.866 40.5L616.866 45.6962L616 45.1962L619 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 40L627.866 40.5L624.866 45.6962L624 45.1962L627 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 40L635.866 40.5L632.866 45.6962L632 45.1962L635 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 40L643.866 40.5L640.866 45.6962L640 45.1962L643 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 40L651.866 40.5L648.866 45.6962L648 45.1962L651 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 40L659.866 40.5L656.866 45.6962L656 45.1962L659 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 40L667.866 40.5L664.866 45.6962L664 45.1962L667 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 40L675.866 40.5L672.866 45.6962L672 45.1962L675 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 40L683.866 40.5L680.866 45.6962L680 45.1962L683 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 40L691.866 40.5L688.866 45.6962L688 45.1962L691 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 40L699.866 40.5L696.866 45.6962L696 45.1962L699 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 40L707.866 40.5L704.866 45.6962L704 45.1962L707 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 40L715.866 40.5L712.866 45.6962L712 45.1962L715 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 40L723.866 40.5L720.866 45.6962L720 45.1962L723 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 40L731.866 40.5L728.866 45.6962L728 45.1962L731 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 40L739.866 40.5L736.866 45.6962L736 45.1962L739 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 40L747.866 40.5L744.866 45.6962L744 45.1962L747 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 40L755.866 40.5L752.866 45.6962L752 45.1962L755 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 40L763.866 40.5L760.866 45.6962L760 45.1962L763 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 40L771.866 40.5L768.866 45.6962L768 45.1962L771 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 40L779.866 40.5L776.866 45.6962L776 45.1962L779 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 40L787.866 40.5L784.866 45.6962L784 45.1962L787 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 40L795.866 40.5L792.866 45.6962L792 45.1962L795 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 40L803.866 40.5L800.866 45.6962L800 45.1962L803 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 40L811.866 40.5L808.866 45.6962L808 45.1962L811 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 40L819.866 40.5L816.866 45.6962L816 45.1962L819 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 40L827.866 40.5L824.866 45.6962L824 45.1962L827 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 40L835.866 40.5L832.866 45.6962L832 45.1962L835 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 40L843.866 40.5L840.866 45.6962L840 45.1962L843 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 48L427.866 48.5L424.866 53.6962L424 53.1962L427 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 48L435.866 48.5L432.866 53.6962L432 53.1962L435 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 48L443.866 48.5L440.866 53.6962L440 53.1962L443 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 48L451.866 48.5L448.866 53.6962L448 53.1962L451 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 48L459.866 48.5L456.866 53.6962L456 53.1962L459 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 48L467.866 48.5L464.866 53.6962L464 53.1962L467 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 48L475.866 48.5L472.866 53.6962L472 53.1962L475 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 48L483.866 48.5L480.866 53.6962L480 53.1962L483 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 48L491.866 48.5L488.866 53.6962L488 53.1962L491 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 48L499.866 48.5L496.866 53.6962L496 53.1962L499 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 48L507.866 48.5L504.866 53.6962L504 53.1962L507 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 48L515.866 48.5L512.866 53.6962L512 53.1962L515 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 48L523.866 48.5L520.866 53.6962L520 53.1962L523 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 48L531.866 48.5L528.866 53.6962L528 53.1962L531 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 48L539.866 48.5L536.866 53.6962L536 53.1962L539 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 48L547.866 48.5L544.866 53.6962L544 53.1962L547 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 48L555.866 48.5L552.866 53.6962L552 53.1962L555 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 48L563.866 48.5L560.866 53.6962L560 53.1962L563 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 48L571.866 48.5L568.866 53.6962L568 53.1962L571 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 48L579.866 48.5L576.866 53.6962L576 53.1962L579 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 48L587.866 48.5L584.866 53.6962L584 53.1962L587 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 48L595.866 48.5L592.866 53.6962L592 53.1962L595 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 48L603.866 48.5L600.866 53.6962L600 53.1962L603 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 48L611.866 48.5L608.866 53.6962L608 53.1962L611 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 48L619.866 48.5L616.866 53.6962L616 53.1962L619 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 48L627.866 48.5L624.866 53.6962L624 53.1962L627 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 48L635.866 48.5L632.866 53.6962L632 53.1962L635 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 48L643.866 48.5L640.866 53.6962L640 53.1962L643 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 48L651.866 48.5L648.866 53.6962L648 53.1962L651 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 48L659.866 48.5L656.866 53.6962L656 53.1962L659 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 48L667.866 48.5L664.866 53.6962L664 53.1962L667 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 48L675.866 48.5L672.866 53.6962L672 53.1962L675 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 48L683.866 48.5L680.866 53.6962L680 53.1962L683 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 48L691.866 48.5L688.866 53.6962L688 53.1962L691 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 48L699.866 48.5L696.866 53.6962L696 53.1962L699 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 48L707.866 48.5L704.866 53.6962L704 53.1962L707 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 48L715.866 48.5L712.866 53.6962L712 53.1962L715 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 48L723.866 48.5L720.866 53.6962L720 53.1962L723 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 48L731.866 48.5L728.866 53.6962L728 53.1962L731 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 48L739.866 48.5L736.866 53.6962L736 53.1962L739 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 48L747.866 48.5L744.866 53.6962L744 53.1962L747 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 48L755.866 48.5L752.866 53.6962L752 53.1962L755 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 48L763.866 48.5L760.866 53.6962L760 53.1962L763 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 48L771.866 48.5L768.866 53.6962L768 53.1962L771 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 48L779.866 48.5L776.866 53.6962L776 53.1962L779 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 48L787.866 48.5L784.866 53.6962L784 53.1962L787 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 48L795.866 48.5L792.866 53.6962L792 53.1962L795 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 48L803.866 48.5L800.866 53.6962L800 53.1962L803 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 48L811.866 48.5L808.866 53.6962L808 53.1962L811 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 48L819.866 48.5L816.866 53.6962L816 53.1962L819 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 48L827.866 48.5L824.866 53.6962L824 53.1962L827 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 48L835.866 48.5L832.866 53.6962L832 53.1962L835 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 48L843.866 48.5L840.866 53.6962L840 53.1962L843 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 56L427.866 56.5L424.866 61.6962L424 61.1962L427 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 56L435.866 56.5L432.866 61.6962L432 61.1962L435 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 56L443.866 56.5L440.866 61.6962L440 61.1962L443 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 56L451.866 56.5L448.866 61.6962L448 61.1962L451 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 56L459.866 56.5L456.866 61.6962L456 61.1962L459 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 56L467.866 56.5L464.866 61.6962L464 61.1962L467 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 56L475.866 56.5L472.866 61.6962L472 61.1962L475 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 56L483.866 56.5L480.866 61.6962L480 61.1962L483 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 56L491.866 56.5L488.866 61.6962L488 61.1962L491 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 56L499.866 56.5L496.866 61.6962L496 61.1962L499 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 56L507.866 56.5L504.866 61.6962L504 61.1962L507 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 56L515.866 56.5L512.866 61.6962L512 61.1962L515 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 56L523.866 56.5L520.866 61.6962L520 61.1962L523 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 56L531.866 56.5L528.866 61.6962L528 61.1962L531 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 56L539.866 56.5L536.866 61.6962L536 61.1962L539 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 56L547.866 56.5L544.866 61.6962L544 61.1962L547 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 56L555.866 56.5L552.866 61.6962L552 61.1962L555 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 56L563.866 56.5L560.866 61.6962L560 61.1962L563 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 56L571.866 56.5L568.866 61.6962L568 61.1962L571 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 56L579.866 56.5L576.866 61.6962L576 61.1962L579 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 56L587.866 56.5L584.866 61.6962L584 61.1962L587 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 56L595.866 56.5L592.866 61.6962L592 61.1962L595 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 56L603.866 56.5L600.866 61.6962L600 61.1962L603 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 56L611.866 56.5L608.866 61.6962L608 61.1962L611 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 56L619.866 56.5L616.866 61.6962L616 61.1962L619 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 56L627.866 56.5L624.866 61.6962L624 61.1962L627 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 56L635.866 56.5L632.866 61.6962L632 61.1962L635 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 56L643.866 56.5L640.866 61.6962L640 61.1962L643 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 56L651.866 56.5L648.866 61.6962L648 61.1962L651 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 56L659.866 56.5L656.866 61.6962L656 61.1962L659 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 56L667.866 56.5L664.866 61.6962L664 61.1962L667 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 56L675.866 56.5L672.866 61.6962L672 61.1962L675 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 56L683.866 56.5L680.866 61.6962L680 61.1962L683 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 56L691.866 56.5L688.866 61.6962L688 61.1962L691 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 56L699.866 56.5L696.866 61.6962L696 61.1962L699 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 56L707.866 56.5L704.866 61.6962L704 61.1962L707 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 56L715.866 56.5L712.866 61.6962L712 61.1962L715 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 56L723.866 56.5L720.866 61.6962L720 61.1962L723 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 56L731.866 56.5L728.866 61.6962L728 61.1962L731 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 56L739.866 56.5L736.866 61.6962L736 61.1962L739 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 56L747.866 56.5L744.866 61.6962L744 61.1962L747 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 56L755.866 56.5L752.866 61.6962L752 61.1962L755 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 56L763.866 56.5L760.866 61.6962L760 61.1962L763 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 56L771.866 56.5L768.866 61.6962L768 61.1962L771 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 56L779.866 56.5L776.866 61.6962L776 61.1962L779 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 56L787.866 56.5L784.866 61.6962L784 61.1962L787 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 56L795.866 56.5L792.866 61.6962L792 61.1962L795 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 56L803.866 56.5L800.866 61.6962L800 61.1962L803 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 56L811.866 56.5L808.866 61.6962L808 61.1962L811 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 56L819.866 56.5L816.866 61.6962L816 61.1962L819 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 56L827.866 56.5L824.866 61.6962L824 61.1962L827 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 56L835.866 56.5L832.866 61.6962L832 61.1962L835 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 56L843.866 56.5L840.866 61.6962L840 61.1962L843 56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 64L427.866 64.5L424.866 69.6962L424 69.1962L427 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 64L435.866 64.5L432.866 69.6962L432 69.1962L435 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 64L443.866 64.5L440.866 69.6962L440 69.1962L443 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 64L451.866 64.5L448.866 69.6962L448 69.1962L451 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 64L459.866 64.5L456.866 69.6962L456 69.1962L459 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 64L467.866 64.5L464.866 69.6962L464 69.1962L467 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 64L475.866 64.5L472.866 69.6962L472 69.1962L475 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 64L483.866 64.5L480.866 69.6962L480 69.1962L483 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 64L491.866 64.5L488.866 69.6962L488 69.1962L491 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 64L499.866 64.5L496.866 69.6962L496 69.1962L499 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 64L507.866 64.5L504.866 69.6962L504 69.1962L507 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 64L515.866 64.5L512.866 69.6962L512 69.1962L515 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 64L523.866 64.5L520.866 69.6962L520 69.1962L523 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 64L531.866 64.5L528.866 69.6962L528 69.1962L531 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 64L539.866 64.5L536.866 69.6962L536 69.1962L539 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 64L547.866 64.5L544.866 69.6962L544 69.1962L547 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 64L555.866 64.5L552.866 69.6962L552 69.1962L555 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 64L563.866 64.5L560.866 69.6962L560 69.1962L563 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 64L571.866 64.5L568.866 69.6962L568 69.1962L571 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 64L579.866 64.5L576.866 69.6962L576 69.1962L579 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 64L587.866 64.5L584.866 69.6962L584 69.1962L587 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 64L595.866 64.5L592.866 69.6962L592 69.1962L595 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 64L603.866 64.5L600.866 69.6962L600 69.1962L603 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 64L611.866 64.5L608.866 69.6962L608 69.1962L611 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 64L619.866 64.5L616.866 69.6962L616 69.1962L619 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 64L627.866 64.5L624.866 69.6962L624 69.1962L627 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 64L635.866 64.5L632.866 69.6962L632 69.1962L635 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 64L643.866 64.5L640.866 69.6962L640 69.1962L643 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 64L651.866 64.5L648.866 69.6962L648 69.1962L651 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 64L659.866 64.5L656.866 69.6962L656 69.1962L659 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 64L667.866 64.5L664.866 69.6962L664 69.1962L667 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 64L675.866 64.5L672.866 69.6962L672 69.1962L675 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 64L683.866 64.5L680.866 69.6962L680 69.1962L683 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 64L691.866 64.5L688.866 69.6962L688 69.1962L691 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 64L699.866 64.5L696.866 69.6962L696 69.1962L699 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 64L707.866 64.5L704.866 69.6962L704 69.1962L707 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 64L715.866 64.5L712.866 69.6962L712 69.1962L715 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 64L723.866 64.5L720.866 69.6962L720 69.1962L723 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 64L731.866 64.5L728.866 69.6962L728 69.1962L731 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 64L739.866 64.5L736.866 69.6962L736 69.1962L739 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 64L747.866 64.5L744.866 69.6962L744 69.1962L747 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 64L755.866 64.5L752.866 69.6962L752 69.1962L755 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 64L763.866 64.5L760.866 69.6962L760 69.1962L763 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 64L771.866 64.5L768.866 69.6962L768 69.1962L771 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 64L779.866 64.5L776.866 69.6962L776 69.1962L779 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 64L787.866 64.5L784.866 69.6962L784 69.1962L787 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 64L795.866 64.5L792.866 69.6962L792 69.1962L795 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 64L803.866 64.5L800.866 69.6962L800 69.1962L803 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 64L811.866 64.5L808.866 69.6962L808 69.1962L811 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 64L819.866 64.5L816.866 69.6962L816 69.1962L819 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 64L827.866 64.5L824.866 69.6962L824 69.1962L827 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 64L835.866 64.5L832.866 69.6962L832 69.1962L835 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 64L843.866 64.5L840.866 69.6962L840 69.1962L843 64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 72L427.866 72.5L424.866 77.6962L424 77.1962L427 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 72L435.866 72.5L432.866 77.6962L432 77.1962L435 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 72L443.866 72.5L440.866 77.6962L440 77.1962L443 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 72L451.866 72.5L448.866 77.6962L448 77.1962L451 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 72L459.866 72.5L456.866 77.6962L456 77.1962L459 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 72L467.866 72.5L464.866 77.6962L464 77.1962L467 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 72L475.866 72.5L472.866 77.6962L472 77.1962L475 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 72L483.866 72.5L480.866 77.6962L480 77.1962L483 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 72L491.866 72.5L488.866 77.6962L488 77.1962L491 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 72L499.866 72.5L496.866 77.6962L496 77.1962L499 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 72L507.866 72.5L504.866 77.6962L504 77.1962L507 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 72L515.866 72.5L512.866 77.6962L512 77.1962L515 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 72L523.866 72.5L520.866 77.6962L520 77.1962L523 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 72L531.866 72.5L528.866 77.6962L528 77.1962L531 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 72L539.866 72.5L536.866 77.6962L536 77.1962L539 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 72L547.866 72.5L544.866 77.6962L544 77.1962L547 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 72L555.866 72.5L552.866 77.6962L552 77.1962L555 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 72L563.866 72.5L560.866 77.6962L560 77.1962L563 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 72L571.866 72.5L568.866 77.6962L568 77.1962L571 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 72L579.866 72.5L576.866 77.6962L576 77.1962L579 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 72L587.866 72.5L584.866 77.6962L584 77.1962L587 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 72L595.866 72.5L592.866 77.6962L592 77.1962L595 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 72L603.866 72.5L600.866 77.6962L600 77.1962L603 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 72L611.866 72.5L608.866 77.6962L608 77.1962L611 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 72L619.866 72.5L616.866 77.6962L616 77.1962L619 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 72L627.866 72.5L624.866 77.6962L624 77.1962L627 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 72L635.866 72.5L632.866 77.6962L632 77.1962L635 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 72L643.866 72.5L640.866 77.6962L640 77.1962L643 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 72L651.866 72.5L648.866 77.6962L648 77.1962L651 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 72L659.866 72.5L656.866 77.6962L656 77.1962L659 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 72L667.866 72.5L664.866 77.6962L664 77.1962L667 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 72L675.866 72.5L672.866 77.6962L672 77.1962L675 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 72L683.866 72.5L680.866 77.6962L680 77.1962L683 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 72L691.866 72.5L688.866 77.6962L688 77.1962L691 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 72L699.866 72.5L696.866 77.6962L696 77.1962L699 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 72L707.866 72.5L704.866 77.6962L704 77.1962L707 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 72L715.866 72.5L712.866 77.6962L712 77.1962L715 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 72L723.866 72.5L720.866 77.6962L720 77.1962L723 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 72L731.866 72.5L728.866 77.6962L728 77.1962L731 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 72L739.866 72.5L736.866 77.6962L736 77.1962L739 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 72L747.866 72.5L744.866 77.6962L744 77.1962L747 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 72L755.866 72.5L752.866 77.6962L752 77.1962L755 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 72L763.866 72.5L760.866 77.6962L760 77.1962L763 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 72L771.866 72.5L768.866 77.6962L768 77.1962L771 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 72L779.866 72.5L776.866 77.6962L776 77.1962L779 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 72L787.866 72.5L784.866 77.6962L784 77.1962L787 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 72L795.866 72.5L792.866 77.6962L792 77.1962L795 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 72L803.866 72.5L800.866 77.6962L800 77.1962L803 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 72L811.866 72.5L808.866 77.6962L808 77.1962L811 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 72L819.866 72.5L816.866 77.6962L816 77.1962L819 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 72L827.866 72.5L824.866 77.6962L824 77.1962L827 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 72L835.866 72.5L832.866 77.6962L832 77.1962L835 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 72L843.866 72.5L840.866 77.6962L840 77.1962L843 72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 80L427.866 80.5L424.866 85.6962L424 85.1962L427 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 80L435.866 80.5L432.866 85.6962L432 85.1962L435 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 80L443.866 80.5L440.866 85.6962L440 85.1962L443 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 80L451.866 80.5L448.866 85.6962L448 85.1962L451 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 80L459.866 80.5L456.866 85.6962L456 85.1962L459 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 80L467.866 80.5L464.866 85.6962L464 85.1962L467 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 80L475.866 80.5L472.866 85.6962L472 85.1962L475 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 80L483.866 80.5L480.866 85.6962L480 85.1962L483 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 80L491.866 80.5L488.866 85.6962L488 85.1962L491 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 80L499.866 80.5L496.866 85.6962L496 85.1962L499 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 80L507.866 80.5L504.866 85.6962L504 85.1962L507 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 80L515.866 80.5L512.866 85.6962L512 85.1962L515 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 80L523.866 80.5L520.866 85.6962L520 85.1962L523 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 80L531.866 80.5L528.866 85.6962L528 85.1962L531 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 80L539.866 80.5L536.866 85.6962L536 85.1962L539 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 80L547.866 80.5L544.866 85.6962L544 85.1962L547 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 80L555.866 80.5L552.866 85.6962L552 85.1962L555 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 80L563.866 80.5L560.866 85.6962L560 85.1962L563 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 80L571.866 80.5L568.866 85.6962L568 85.1962L571 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 80L579.866 80.5L576.866 85.6962L576 85.1962L579 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 80L587.866 80.5L584.866 85.6962L584 85.1962L587 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 80L595.866 80.5L592.866 85.6962L592 85.1962L595 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 80L603.866 80.5L600.866 85.6962L600 85.1962L603 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 80L611.866 80.5L608.866 85.6962L608 85.1962L611 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 80L619.866 80.5L616.866 85.6962L616 85.1962L619 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 80L627.866 80.5L624.866 85.6962L624 85.1962L627 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 80L635.866 80.5L632.866 85.6962L632 85.1962L635 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 80L643.866 80.5L640.866 85.6962L640 85.1962L643 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 80L651.866 80.5L648.866 85.6962L648 85.1962L651 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 80L659.866 80.5L656.866 85.6962L656 85.1962L659 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 80L667.866 80.5L664.866 85.6962L664 85.1962L667 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 80L675.866 80.5L672.866 85.6962L672 85.1962L675 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 80L683.866 80.5L680.866 85.6962L680 85.1962L683 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 80L691.866 80.5L688.866 85.6962L688 85.1962L691 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 80L699.866 80.5L696.866 85.6962L696 85.1962L699 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 80L707.866 80.5L704.866 85.6962L704 85.1962L707 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 80L715.866 80.5L712.866 85.6962L712 85.1962L715 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 80L723.866 80.5L720.866 85.6962L720 85.1962L723 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 80L731.866 80.5L728.866 85.6962L728 85.1962L731 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 80L739.866 80.5L736.866 85.6962L736 85.1962L739 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 80L747.866 80.5L744.866 85.6962L744 85.1962L747 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 80L755.866 80.5L752.866 85.6962L752 85.1962L755 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 80L763.866 80.5L760.866 85.6962L760 85.1962L763 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 80L771.866 80.5L768.866 85.6962L768 85.1962L771 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 80L779.866 80.5L776.866 85.6962L776 85.1962L779 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 80L787.866 80.5L784.866 85.6962L784 85.1962L787 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 80L795.866 80.5L792.866 85.6962L792 85.1962L795 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 80L803.866 80.5L800.866 85.6962L800 85.1962L803 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 80L811.866 80.5L808.866 85.6962L808 85.1962L811 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 80L819.866 80.5L816.866 85.6962L816 85.1962L819 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 80L827.866 80.5L824.866 85.6962L824 85.1962L827 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 80L835.866 80.5L832.866 85.6962L832 85.1962L835 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 80L843.866 80.5L840.866 85.6962L840 85.1962L843 80Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 88L427.866 88.5L424.866 93.6962L424 93.1962L427 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 88L435.866 88.5L432.866 93.6962L432 93.1962L435 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 88L443.866 88.5L440.866 93.6962L440 93.1962L443 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 88L451.866 88.5L448.866 93.6962L448 93.1962L451 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 88L459.866 88.5L456.866 93.6962L456 93.1962L459 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 88L467.866 88.5L464.866 93.6962L464 93.1962L467 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 88L475.866 88.5L472.866 93.6962L472 93.1962L475 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 88L483.866 88.5L480.866 93.6962L480 93.1962L483 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 88L491.866 88.5L488.866 93.6962L488 93.1962L491 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 88L499.866 88.5L496.866 93.6962L496 93.1962L499 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 88L507.866 88.5L504.866 93.6962L504 93.1962L507 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 88L515.866 88.5L512.866 93.6962L512 93.1962L515 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 88L523.866 88.5L520.866 93.6962L520 93.1962L523 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 88L531.866 88.5L528.866 93.6962L528 93.1962L531 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 88L539.866 88.5L536.866 93.6962L536 93.1962L539 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 88L547.866 88.5L544.866 93.6962L544 93.1962L547 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 88L555.866 88.5L552.866 93.6962L552 93.1962L555 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 88L563.866 88.5L560.866 93.6962L560 93.1962L563 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 88L571.866 88.5L568.866 93.6962L568 93.1962L571 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 88L579.866 88.5L576.866 93.6962L576 93.1962L579 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 88L587.866 88.5L584.866 93.6962L584 93.1962L587 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 88L595.866 88.5L592.866 93.6962L592 93.1962L595 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 88L603.866 88.5L600.866 93.6962L600 93.1962L603 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 88L611.866 88.5L608.866 93.6962L608 93.1962L611 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 88L619.866 88.5L616.866 93.6962L616 93.1962L619 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 88L627.866 88.5L624.866 93.6962L624 93.1962L627 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 88L635.866 88.5L632.866 93.6962L632 93.1962L635 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 88L643.866 88.5L640.866 93.6962L640 93.1962L643 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 88L651.866 88.5L648.866 93.6962L648 93.1962L651 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 88L659.866 88.5L656.866 93.6962L656 93.1962L659 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 88L667.866 88.5L664.866 93.6962L664 93.1962L667 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 88L675.866 88.5L672.866 93.6962L672 93.1962L675 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 88L683.866 88.5L680.866 93.6962L680 93.1962L683 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 88L691.866 88.5L688.866 93.6962L688 93.1962L691 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 88L699.866 88.5L696.866 93.6962L696 93.1962L699 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 88L707.866 88.5L704.866 93.6962L704 93.1962L707 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 88L715.866 88.5L712.866 93.6962L712 93.1962L715 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 88L723.866 88.5L720.866 93.6962L720 93.1962L723 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 88L731.866 88.5L728.866 93.6962L728 93.1962L731 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 88L739.866 88.5L736.866 93.6962L736 93.1962L739 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 88L747.866 88.5L744.866 93.6962L744 93.1962L747 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 88L755.866 88.5L752.866 93.6962L752 93.1962L755 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 88L763.866 88.5L760.866 93.6962L760 93.1962L763 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 88L771.866 88.5L768.866 93.6962L768 93.1962L771 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 88L779.866 88.5L776.866 93.6962L776 93.1962L779 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 88L787.866 88.5L784.866 93.6962L784 93.1962L787 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 88L795.866 88.5L792.866 93.6962L792 93.1962L795 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 88L803.866 88.5L800.866 93.6962L800 93.1962L803 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 88L811.866 88.5L808.866 93.6962L808 93.1962L811 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 88L819.866 88.5L816.866 93.6962L816 93.1962L819 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 88L827.866 88.5L824.866 93.6962L824 93.1962L827 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 88L835.866 88.5L832.866 93.6962L832 93.1962L835 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 88L843.866 88.5L840.866 93.6962L840 93.1962L843 88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 96L427.866 96.5L424.866 101.696L424 101.196L427 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 96L435.866 96.5L432.866 101.696L432 101.196L435 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443 96L443.866 96.5L440.866 101.696L440 101.196L443 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 96L451.866 96.5L448.866 101.696L448 101.196L451 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 96L459.866 96.5L456.866 101.696L456 101.196L459 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467 96L467.866 96.5L464.866 101.696L464 101.196L467 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 96L475.866 96.5L472.866 101.696L472 101.196L475 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 96L483.866 96.5L480.866 101.696L480 101.196L483 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 96L491.866 96.5L488.866 101.696L488 101.196L491 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499 96L499.866 96.5L496.866 101.696L496 101.196L499 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 96L507.866 96.5L504.866 101.696L504 101.196L507 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 96L515.866 96.5L512.866 101.696L512 101.196L515 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 96L523.866 96.5L520.866 101.696L520 101.196L523 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531 96L531.866 96.5L528.866 101.696L528 101.196L531 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 96L539.866 96.5L536.866 101.696L536 101.196L539 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 96L547.866 96.5L544.866 101.696L544 101.196L547 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 96L555.866 96.5L552.866 101.696L552 101.196L555 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 96L563.866 96.5L560.866 101.696L560 101.196L563 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571 96L571.866 96.5L568.866 101.696L568 101.196L571 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579 96L579.866 96.5L576.866 101.696L576 101.196L579 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587 96L587.866 96.5L584.866 101.696L584 101.196L587 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 96L595.866 96.5L592.866 101.696L592 101.196L595 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 96L603.866 96.5L600.866 101.696L600 101.196L603 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611 96L611.866 96.5L608.866 101.696L608 101.196L611 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619 96L619.866 96.5L616.866 101.696L616 101.196L619 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 96L627.866 96.5L624.866 101.696L624 101.196L627 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635 96L635.866 96.5L632.866 101.696L632 101.196L635 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643 96L643.866 96.5L640.866 101.696L640 101.196L643 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651 96L651.866 96.5L648.866 101.696L648 101.196L651 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 96L659.866 96.5L656.866 101.696L656 101.196L659 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667 96L667.866 96.5L664.866 101.696L664 101.196L667 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675 96L675.866 96.5L672.866 101.696L672 101.196L675 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683 96L683.866 96.5L680.866 101.696L680 101.196L683 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691 96L691.866 96.5L688.866 101.696L688 101.196L691 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699 96L699.866 96.5L696.866 101.696L696 101.196L699 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707 96L707.866 96.5L704.866 101.696L704 101.196L707 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715 96L715.866 96.5L712.866 101.696L712 101.196L715 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723 96L723.866 96.5L720.866 101.696L720 101.196L723 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731 96L731.866 96.5L728.866 101.696L728 101.196L731 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739 96L739.866 96.5L736.866 101.696L736 101.196L739 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747 96L747.866 96.5L744.866 101.696L744 101.196L747 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755 96L755.866 96.5L752.866 101.696L752 101.196L755 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763 96L763.866 96.5L760.866 101.696L760 101.196L763 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771 96L771.866 96.5L768.866 101.696L768 101.196L771 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779 96L779.866 96.5L776.866 101.696L776 101.196L779 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787 96L787.866 96.5L784.866 101.696L784 101.196L787 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795 96L795.866 96.5L792.866 101.696L792 101.196L795 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803 96L803.866 96.5L800.866 101.696L800 101.196L803 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811 96L811.866 96.5L808.866 101.696L808 101.196L811 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819 96L819.866 96.5L816.866 101.696L816 101.196L819 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 96L827.866 96.5L824.866 101.696L824 101.196L827 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835 96L835.866 96.5L832.866 101.696L832 101.196L835 96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 96L843.866 96.5L840.866 101.696L840 101.196L843 96Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgContinent);
export default __webpack_public_path__ + "static/media/bgContinent.c8737dd47a4eb880ded5b679d3035acd.svg";
export { ForwardRef as ReactComponent };